import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import withLogger from 'modules/shell/hoc/withLogger';
import withBrowserHistory from 'modules/shell/hoc/withBrowserHistory';
import styles from './NotFound.styles';
import NotFound from './NotFound';

export default compose(
  withStyles(styles),
  withLogger(),
  withBrowserHistory(),
  withRouter,
)(NotFound);
